import General from '../../utils/GeneralUtils';

/**
 * react-select styling for the match run forms, lifted verbatim from the enrichment
 * create page so the dropdowns keep matching the rest of the app.
 */
export const selectStyles = {
  ...General.getCreatableStylesCompact(),
  control: (provided: any, state: any) => ({
    ...provided,
    padding: '0',
    minHeight: '36px',
    transition: 'none',
    backgroundColor: 'var(--input-bg)',
    borderColor: state.isFocused ? 'var(--amplify-colors-purple-65)' : 'var(--input-border)',
    boxShadow: state.isFocused ? '0 0 0 3px var(--amplify-colors-purple-30)' : 'none',
    borderRadius: 'var(--amplify-components-button-border-radius)',
    '&:hover': {
      borderColor: 'var(--amplify-colors-purple-65)',
    },
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: '0 8px',
    backgroundColor: 'transparent',
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: 'var(--input-color)',
    fontSize: '14px',
  }),
  input: (provided: any) => ({
    ...provided,
    color: 'var(--input-color)',
    margin: 0,
    padding: 0,
    fontSize: '14px',
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: 'var(--amplify-colors-neutral-60)',
    fontSize: '14px',
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontSize: '13px',
    padding: '6px 10px',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    backgroundColor: state.isSelected
      ? 'transparent'
      : 'var(--amplify-colors-neutral-0)',
    color: state.isDisabled
      ? 'var(--amplify-colors-neutral-50)'
      : 'var(--amplify-colors-font-primary)',
    ':hover': {
      backgroundColor: state.isDisabled
        ? 'transparent'
        : 'var(--amplify-colors-neutral-20)',
    },
  }),
};
